<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  data() {
    return {
      chartOptions: {
        calendar: {
          range: "2024",
          cellSize: ["auto", 20]
        },
        series: {
          type: "heatmap",
          coordinateSystem: "calendar",
          data: [
            ["2024-01-01", 10],
            ["2024-02-01", 20],
            ["2024-03-01", 30]
          ]
        }
      }
    };
  }
};
</script>
